import React from "react";
export default function Loader() {
  return (
    <app-loader
      _ngcontent-ng-c75588018=""
      _nghost-ng-c2690516186=""
      class="ng-star-inserted"
      style={{
        height: "100%",
      }}
    >
      <div _ngcontent-ng-c2690516186="" class="overlay">
        <div _ngcontent-ng-c2690516186="" class="loader-body">
          <div _ngcontent-ng-c2690516186="" class="body-container shadow">
            <div _ngcontent-ng-c2690516186="" class="circle-container">
              <div
                _ngcontent-ng-c2690516186=""
                data-animation=""
                class="circle a-slide"
                style={{ "--bgc": "var(--loader1-bg)" }}
              ></div>
              <div
                _ngcontent-ng-c2690516186=""
                data-animation=""
                class="circle a-slide a-return"
                style={{ "--bgc": "var(--loader2-bg)" }}
              ></div>
            </div>
            <div _ngcontent-ng-c2690516186="" class="loading-text">
              Loading...
            </div>
          </div>
        </div>
      </div>
    </app-loader>
  );
}
